export class AudioWaveCircle {
  constructor(svgElement, options = {}) {
      this.svg = svgElement;
      this.options = {
          radius: options.radius || 80,
          points: options.points || 128,
          maxAmplitude: options.maxAmplitude || 20,
          strokeColor: options.strokeColor || '#2196F3',
          strokeWidth: options.strokeWidth || 2,
          smoothing: options.smoothing || 0.85,
          updateInterval: options.updateInterval || 50 // milliseconds
      };

      this.group = this.svg.querySelector('g');
      this.path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.path.setAttribute('stroke', this.options.strokeColor);
      this.path.setAttribute('stroke-width', this.options.strokeWidth);
      this.path.setAttribute('fill', 'none');
      this.path.classList.add('wave-path');
      this.group.appendChild(this.path);

      this.dataArray = new Float32Array(this.options.points);
      this.currentAmplitudes = new Float32Array(this.options.points).fill(0);
      this.updateInterval = null;
  }

  start(audioData) {
      this.updateInterval = setInterval(() => {

        audioData = this.simulateAudioData();
        this.update(audioData);

      }, this.options.updateInterval);
  }

  stop() {
      if (this.updateInterval) {
          clearInterval(this.updateInterval);
          this.updateInterval = null;
      }
  }

  update(audioData) {


    // debug audio stream
    // console.info("updating audio data, ", audioData);


    // Normalize audio data to match points count
    const step = Math.floor(audioData.length / this.options.points);
    for (let i = 0; i < this.options.points; i++) {
        const dataIndex = i * step;
        this.dataArray[i] = audioData[dataIndex] || 0;
    }

    // Smooth transitions
    for (let i = 0; i < this.options.points; i++) {
        this.currentAmplitudes[i] = this.options.smoothing * this.currentAmplitudes[i] +
            (1 - this.options.smoothing) * Math.abs(this.dataArray[i]);
    }

    this.draw();
  }

  draw() {
      const points = [];
      const angleStep = (2 * Math.PI) / this.options.points;

      for (let i = 0; i < this.options.points; i++) {
          const angle = i * angleStep;
          const amplitude = this.currentAmplitudes[i] * this.options.maxAmplitude;
          const radius = this.options.radius + amplitude;

          const x = radius * Math.cos(angle);
          const y = radius * Math.sin(angle);

          points.push([x, y]);
      }

      const pathData = this.createSmoothPath(points);
      this.path.setAttribute('d', pathData);

      this.group.style.display = 'block';
  }

  undraw() {
    if (this.group) {
        this.stop(); // Stop the interval
        while (this.group.firstChild) {
            this.group.removeChild(this.group.firstChild); // Remove all children from the group
        }
        this.group.style.display = 'none'; // Hide the group
    }
  }

  createSmoothPath(points) {
      if (points.length < 2) return '';

      let path = `M ${points[0][0]},${points[0][1]}`;

      for (let i = 0; i < points.length; i++) {
          const p0 = points[(i - 1 + points.length) % points.length];
          const p1 = points[i];
          const p2 = points[(i + 1) % points.length];
          const p3 = points[(i + 2) % points.length];

          const cp1x = p1[0] + (p2[0] - p0[0]) / 6;
          const cp1y = p1[1] + (p2[1] - p0[1]) / 6;
          const cp2x = p2[0] - (p3[0] - p1[0]) / 6;
          const cp2y = p2[1] - (p3[1] - p1[1]) / 6;

          path += ` C ${cp1x},${cp1y} ${cp2x},${cp2y} ${p2[0]},${p2[1]}`;
      }

      path += 'Z';
      return path;
  }

  // Simulate audio data for testing
  simulateAudioData() {
      const data = new Float32Array(1024);
      for (let i = 0; i < data.length; i++) {
          data[i] = (Math.random() * 2 - 1) * 0.5;
      }
      return data;
  }

  // // Method to handle real microphone input
  // async initMicrophone() {
  //     try {
  //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //         const audioContext = new AudioContext();
  //         const source = audioContext.createMediaStreamSource(stream);
  //         const analyzer = audioContext.createAnalyser();
  //         analyzer.fftSize = 2048;

  //         source.connect(analyzer);

  //         const dataArray = new Float32Array(analyzer.frequencyBinCount);

  //         // Use setInterval instead of requestAnimationFrame
  //         this.updateInterval = setInterval(() => {
  //             analyzer.getFloatTimeDomainData(dataArray);
  //             this.update(dataArray);
  //         }, this.options.updateInterval);

  //     } catch (error) {
  //         console.error('Error accessing microphone:', error);
  //     }
  // }



}
